export default function CallbackForm($object) {

    var busy = false,
        $loader = $object.find('.js-loader'),
        $form = $object.find('form'),
        $formHolder = $object.find('.js-form-holder'),
        $successHolder = $object.find('.js-success'),
        $errorHolder = $object.find('.js-error'),
        $submitButton = $object.find('a.js-submit,button.js-submit,input.js-submit'),
        validator = $form.validate({
            rules: {
                phone: {
                    required: $form.find('input[name="phone"]').length > 0,
                    rightPhone: $form.find('input[name="phone"]').length > 0,
                },
                email: {
                    required: $form.find('input[name="email"]').length > 0,
                    rightEmail: $form.find('input[name="email"]').length > 0,
                },
            },
            submitHandler: function() {
                console.log('submitHandler')
                submit()
            },
        });

    $submitButton.on('click', function () {
        $form.submit();
    });

    function submit() {
        if (validator.valid()) {
            load();
        }
    }

    async function load() {

        if (busy === false) {

            busy = true;

            showLoader();

            let response = await fetch($form.attr('action'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify($form.serializeObject())
            });

            $submitButton.attr('disabled', 'disabled');

            let json = await response.json();
            console.log('response', response);
            console.log('response json = ', json);
            response.ok ? success(json) : error(json);

            busy = false;

            hideLoader();
            console.log('remove disabled', $submitButton);
            $submitButton.removeAttr('disabled');
        }
    }

    function success(response) {
        console.log('success', response);

        busy = false;

        if (response.errors !== undefined) {
            if ($.isPlainObject(response.errors)) {
                validator.showErrors(response.errors);
            } else {
                $object.find('.js-error-message').html(response.errors);
                $errorHolder.show();
                $formHolder.hide();
            }
        } else {
            var form_type = $form.find('[name=form]').val();
            if (form_type === 'Бриф - упаковка') {
                document.dispatchEvent(new CustomEvent("form-packing"));
            }
            if (~['Бесплатный аудит маркетинга', 'Бриф - маркетинг'].indexOf(form_type)) {
                document.dispatchEvent(new CustomEvent("form-marketing"));
            }
            document.dispatchEvent(new CustomEvent("form-order"));

            // todo show success window
            console.log('success');
            clearForm();
            $('a.js-lightbox-popup[href="#popup-success"]').first().click();

            //$formHolder.hide();
            //$successHolder.show();
        }
    }

    function error(json) {
        console.log('error', json);

        if (json.errors !== undefined) {
            if ($.isPlainObject(json.errors)) {
                validator.showErrors(json.errors);
            } else {
                /*$object.find('.js-error-message').html(json.message);
                errorHolder.show();
                formHolder.hide();*/
            }
        } else {
            /*$object.find('.js-error-message').html(json.message);
            errorHolder.show();
            formHolder.hide();*/
        }
    }

    function showLoader() {
        $loader.show();
    }

    function hideLoader() {
        $loader.hide();
    }

    function clearForm() {

        $object.find('input:text, textarea').each(function (i, el) {
            $(el).val('');
        });

        $object.find('input:checkbox').each(function (i, el) {
            if ($(el).is(':checked')) {
                $(el).click();
            }
        });
    }

    /*
    showLoader: function () {
        successHolder.hide();
        errorHolder.hide();
    },

    showForm: function () {
        formHolder.show();
        form.find('input:text').first().focus();
        successHolder.hide();
        errorHolder.hide();
    },

    '.js-show-form click': function () {
        showForm();
    }
    // */
}
